import { ReactNode } from 'react';
import { ID, ItemRow, Name, ResourceInfo, ShortcutWrapper, SuffixWrapper } from './Item.styled';

interface ItemProps {
  children?: ReactNode;
  /** Image or icon to display along with name of resource */
  Icon?: ReactNode;
  /** Unique ID for resource to aide in searching */
  id?: number | string;
  /** Name or title of resource */
  name: string;
  /** action to take when selecting item (Enter key) */
  onSelect?: (value: string) => void;
  /** Content always shown at the end of item, usually a keyboard key */
  suffix?: ReactNode;
  /** String value used when searching */
  value: string;
}

export const Item = ({
  children,
  Icon,
  id,
  name,
  onSelect = () => {},
  suffix,
  value,
  ...props
}: ItemProps) => {
  return (
    <ItemRow onSelect={onSelect} value={value} {...props}>
      <ResourceInfo>
        {Icon}
        <Name>{name}</Name>
      </ResourceInfo>
      {id && <ID>{`ID: ${id}`}</ID>}
      {children && <ShortcutWrapper>{children}</ShortcutWrapper>}
      {suffix && <SuffixWrapper>{suffix}</SuffixWrapper>}
    </ItemRow>
  );
};
